import ICloudinaryAsset from '@/libraries/src/cloudinary/ICloudinaryAsset';
import ISlideMaster, { isSlideMaster } from '../master/ISlideMaster';

export default interface ICustomSlide extends ISlideMaster {
	id: string;
	chapterId: string;
	presentationId?: string;
	headline: string;
	copy: string;
	badgeText?: string;
	asset?: ICloudinaryAsset;
}

export function isCustomSlide(slide: ICustomSlide | any): slide is ICustomSlide {
	return (
		isSlideMaster(slide) &&
		((slide as ICustomSlide).chapterId !== undefined &&
			(slide as ICustomSlide).headline !== undefined &&
			(slide as ICustomSlide).copy !== undefined)
	);
}
